import React from "react";
import AppHeader from "./components/header";
import Footer from "./components/footer";
import FloatingChannelButton from "./components/Common-components/FloatingChannelButton";
import { Outlet } from "react-router-dom";

export default function Layout() {
  return (
    <div className="app-layout">
      <AppHeader />
      {/* <Header /> */}
      <main>
        <Outlet />
      </main>
      <Footer />
      <FloatingChannelButton />
    </div>
  );
}
